import { render, staticRenderFns } from "./Fermeture.vue?vue&type=template&id=987c68a6"
import script from "./Fermeture.vue?vue&type=script&lang=js"
export * from "./Fermeture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports